import { Box, Button, Stack, Typography } from '@mui/material';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import { ReactNode } from 'react';
import { AxiosError } from 'axios';
import { AxiosErrorPage } from './components';
import { useLocation } from 'react-router-dom';

type ErrorBoundaryPropsType = {
  children: ReactNode;
};

export const ErrorBoundary = ({ children }: ErrorBoundaryPropsType) => {
  const location = useLocation();
  return (
    <ReactErrorBoundary
      key={location.pathname}
      fallbackRender={({ error, resetErrorBoundary }) => {
        if (error instanceof AxiosError) {
          return <AxiosErrorPage error={error} resetErrorBoundary={resetErrorBoundary} />;
        }
        return (
          <Box height='100vh' display='flex' justifyContent='center' alignItems='center'>
            <Stack alignItems='start' gap={1}>
              <Typography fontSize={16} fontWeight={600}>
                Something went wrong
              </Typography>
              <Typography fontSize={16}>
                The application encountered a temporary error and could not complete your request.
              </Typography>
              <Typography>
                Details: <strong>{error.message}</strong>
              </Typography>
              <Button sx={{ alignSelf: 'center' }} size='large' onClick={resetErrorBoundary}>
                Try again
              </Button>
            </Stack>
          </Box>
        );
      }}
    >
      {children}
    </ReactErrorBoundary>
  );
};
